export const keys = {
    stripePublishableKey:
        "pk_live_51NxhViIIc2mB97NpZCogLyx6c0kxw82NkDlI0G1djaUK3CKu7MirVBAAhHreAbAB8v1VFoCuhZeOHyxjT1pHjPbM00PQFsYgc5",
    baseUrl: "https://phair.io",
    imageBaseUrl: "https://s3.us-east-2.amazonaws.com/phair.bucket.prod.client/",
};

